import { useEffect } from "react";

const TARGET = "https://safeguardsolutiongmbh.info";

export default function App() {
  useEffect(() => {
    window.location.replace(TARGET);
  }, []);

  return (
    <div
      data-testid="redirect-page"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "system-ui, sans-serif",
        background: "#FDFDFD",
        color: "#0A0A0A",
      }}
    >
      <p>
        Redirecting to{" "}
        <a href={TARGET} data-testid="redirect-link" style={{ textDecoration: "underline" }}>
          safeguardsolutiongmbh.info
        </a>
        …
      </p>
    </div>
  );
}
